module.exports = __webpack_public_path__ + "static/media/avatar.124a9d70.svg";